import styled from 'styled-components'

export const MemoryCard = styled.div.attrs({
})`
    padding: 16px;
    margin-bottom: 20px;
    border: .5px solid var(--black-color);
    border-radius: 5px;
    ${
        props => props.warning ? `
            border: 1px solid var(--primary-color);
        ` : ``
    }
`;

export const MemoryLabel = styled.div.attrs({
})`
    font-size: 12px;
    font-weight: bold;
    color: var(--black-color);
    opacity: .7;
    margin-bottom: 4px;
`;

export const MemoryValue = styled.div.attrs({
})`
    font-size: 16px;
    color: var(--black-color);
    margin-bottom: 14px;
    overflow-wrap: anywhere;
`;

export const MemoryChips = styled.div.attrs({
})`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 14px;
`;

export const MemoryChip = styled.div.attrs({
})`
    font-size: 14px;
    color: var(--black-color);
    padding: 4px 12px;
    border: 1px solid var(--secondary-color);
    border-radius: 14px;
`;

export const MemorySummary = styled.div.attrs({
})`
    font-size: 14px;
    color: var(--black-color);
    line-height: 1.5em;
    overflow-wrap: anywhere;
`;

export const MemoryNote = styled.div.attrs({
})`
    font-size: 13px;
    color: var(--black-color);
    opacity: .7;
`;
